import { useEffect } from 'react';

// Fades/slides elements with the `mp-reveal` class into view as the visitor
// scrolls (McKayla's 2026-10-05 design Loom: "when you scroll down, things
// move... it's not just static sitting there"). Styles live in App.css.
// Falls back to showing everything when IntersectionObserver is unavailable.
export const useScrollReveal = () => {
  useEffect(() => {
    const els = Array.from(document.querySelectorAll<HTMLElement>('.mp-reveal'));
    if (!('IntersectionObserver' in window)) {
      els.forEach((el) => el.classList.add('is-visible'));
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('is-visible');
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.15 }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);
};
